<template>
  <b-card :title="$t('message.Guideline.section1')" class="mb-2">
    <b-row class="my-1 px-3">
      <b-col sm="2"><label class="col-form-label">{{ $t('message.Guideline.phase') }}:</label></b-col>
      <b-col sm="4" class="d-flex align-items-center">
        <b-badge :variant="guideline.phase === 20 ? 'danger' : 'secondary'">{{currentGuidelinePhaseLabel}}</b-badge>
      </b-col>
    </b-row>

    <template v-if="this.guideline.phase == this.guidelinePhases.finalPublish">
      <b-row class="my-1 px-3" v-if="guideline.type != null">
        <b-col sm="2"><label class="col-form-label">{{ $t('message.Guideline.dateOfPublication') }}</label></b-col>
        <b-col sm="4"><label class="form-control-plaintext">{{ guideline.date_of_publication }}</label></b-col>

        <b-col sm="2" v-if="guideline.updated_at"><label class="col-form-label">{{ $t('message.Guideline.nameOfJournal') }}</label></b-col>
        <b-col sm="4" v-if="guideline.updated_at"><label class="form-control-plaintext">{{ guideline.name_of_journal }}</label></b-col>
      </b-row>

      <b-row class="my-1 px-3" v-if="guideline.type != null">
        <b-col sm="2"><label class="col-form-label">{{ $t('message.Guideline.doiNumber') }}</label></b-col>
        <b-col sm="4"><label class="form-control-plaintext">{{ guideline.doi_number }}</label></b-col>
      </b-row>
    </template>

    <b-row class="my-1 px-3">
      <b-col sm="2"><label class="col-form-label">{{ $t('message.Guideline.uniqueId') }}:</label></b-col>
      <b-col sm="4"><label class="form-control-plaintext">{{ guideline.unique_id != null ? guideline.unique_id : $t("message.na") }}</label></b-col>
    </b-row>

    <b-row class="my-1 px-3">
      <b-col sm="2"><label class="col-form-label">{{ $t('message.Guideline.name') }}:</label></b-col>
      <b-col sm="4"><label class="form-control-plaintext">{{ guideline.name }}</label></b-col>

      <b-col sm="2" v-if="guideline.created_at"><label class="col-form-label">{{ $t("message.createdAt") }}:</label></b-col>
      <b-col sm="4" v-if="guideline.created_at"><label class="form-control-plaintext">{{ guideline.created_at }}</label></b-col>
    </b-row>

    <b-row class="my-1 px-3" v-if="guideline.type != null">
      <b-col sm="2">
        <label class="col-form-label">{{ $t('message.Guideline.type') }}:</label>
      </b-col>
      <b-col sm="4"><label class="form-control-plaintext">{{ $t('message.Guideline.typesOfManuscript.' + guideline.type)  }}</label></b-col>

      <b-col sm="2" v-if="guideline.updated_at"><label class="col-form-label">{{ $t("message.updatedAt") }}</label></b-col>
      <b-col sm="4" v-if="guideline.updated_at"><label class="form-control-plaintext">{{ guideline.updated_at }}</label></b-col>
    </b-row>

    <b-row class="my-1 px-3">
      <b-col sm="2">
        <label class="col-form-label">{{ $t('message.Guideline.entity') }}:</label>
      </b-col>
      <b-col sm="4"><label class="form-control-plaintext">{{ (guideline.abbreviation_of_committee && guideline.abbreviation_of_committee.label)?guideline.abbreviation_of_committee.label:null }}</label></b-col>
    </b-row>

    <b-row class="my-1 px-3" v-if="guideline.kind_of_work != null">
      <b-col sm="2">
        <label class="col-form-label">{{ $t('message.Guideline.kindsOfWorkLabel') }}</label>
      </b-col>

      <b-col sm="10">
        <label class="form-control-plaintext">{{ $t('message.Guideline.kindsOfWork.' + guideline.kind_of_work)  }}

          <p class="mt-1 preLine" v-if="guideline.kind_of_work == 1">{{ $t('message.Guideline.kindsOfWorkJointDetaild') }} :
            {{ guideline.kind_of_work_joint_description }}
          </p>
        </label>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { GuidelinePhases } from '@/lib/guideline.js';

export default {
  name: 'base-data-left',
  components: {},
  props: ['guideline'],
  data () {
    return {
      guidelinePhases: GuidelinePhases,
    }
  },
  computed: {},
  mounted () {},
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  
</style>